export const ATTENTION_ROW_LIMIT = 5

// Tallest row, a lead with its "Received" line, so every row has the same
// height and the card can reserve exactly the rows its tallest tab shows.
export const ATTENTION_ROW_HEIGHT = 99

// A lead whose intent and "Received" line wrap in a narrow card.
export const ATTENTION_ROW_HEIGHT_COMPACT = 110
